import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { navIcons } from '../iconMap';
import Brand from './Brand';

function NavItems({ items, activePage, onNavigate, t }) {
  return items.map((item) => (
    <button
      type="button"
      className={`nav-item ${activePage === item ? 'active' : ''}`}
      onClick={() => onNavigate(item)}
      key={item}
    >
      <SafeIcon icon={navIcons[item]} />
      <span>{t[item]}</span>
    </button>
  ));
}

export function Sidebar(props) {
  return (
    <aside className="sidebar">
      <Brand light />
      <nav className="sidebar-nav" aria-label={props.t.mobileNavigation}>
        <NavItems {...props} />
      </nav>
      <div className="sidebar-footer">{props.t.demoNotice}</div>
    </aside>
  );
}

export function MobileNav(props) {
  const visibleItems = props.items.includes('profile')
    ? [...props.items.filter((item) => item !== 'profile').slice(0, 4), 'profile']
    : props.items.slice(0, 5);

  return (
    <nav className="mobile-nav" aria-label={props.t.mobileNavigation}>
      <NavItems {...props} items={visibleItems} />
    </nav>
  );
}